export default __webpack_public_path__ + "static/media/football.0ab0af51.svg";